import classNames from "classnames"
import React from "react"
import * as Icons from "../../assets/icons/final"
import { IconName } from "../../data/types"
import styles from "./icon.module.scss"

interface Props extends React.HTMLAttributes<SVGSVGElement> {
  name: IconName
  innerRef?: React.Ref<SVGSVGElement>
}

export function Icon(props: Props) {
  const { className, name, innerRef, ...otherProps } = props
  const combinedClassNames = classNames(className, styles.root)

  if (name === "empty") {
    return <svg className={combinedClassNames} ref={innerRef} width="1em" height="1em" {...otherProps}></svg>
  }

  // HACK adding "null" as a replacement for required boolean on prop definitions
  // Specifying null will not render anything for the icon
  if (name === "null") {
    return null
  }

  const Component = Icons[name]

  // TODO warn?
  if (!Component) {
    console.warn(`Icon rendered with invalid name: ${name}`)
    return null
  }

  return <Component className={combinedClassNames} ref={innerRef} {...otherProps} />
}
